import { GenericHeader, GenericFooter } from '@icij/murmur'

import ChartRoute from './ChartRoute'
import ChartArtsOverview from '../components/ChartArtsOverview.vue'
import ChartCompaniesByCountry from '../components/ChartCompaniesByCountry.vue'
import ChartDocumentTypes from '../components/ChartDocumentTypes.vue'
import ChartLeakSizeDocuments from '../components/ChartLeakSizeDocuments.vue'
import ChartLeakSizeTb from '../components/ChartLeakSizeTb.vue'
import ChartKingOfJordanProperties from '../components/ChartKingOfJordanProperties.vue'
import ChartPoliticiansByCountry from '../components/ChartPoliticiansByCountry.vue'
import ChartPoliticiansForEachJurisdiction from '../components/ChartPoliticiansForEachJurisdiction.vue'
import ChartPoliticiansForEachProvider from '../components/ChartPoliticiansForEachProvider.vue'
import ChartPoliticiansForEachRegion from '../components/ChartPoliticiansForEachRegion.vue'
import ChartProviderPoliticiansByRegion from '../components/ChartProviderPoliticiansByRegion.vue'
import ChartProvidersOverview from '../components/ChartProvidersOverview.vue'
import ChartUsaTopFiveTrusts from '../components/ChartUsaTopFiveTrusts.vue'

import Home from '../views/Home.vue'

export { guards } from './guards'
export { ChartRoute }
export const routes = [
  {
    path: '/',
    name: 'Home',
    props: {
      header: {
        noHeadroom: true,
        position: 'static'
      }
    },
    components: {
      header: GenericHeader,
      footer: GenericFooter,
      default: Home
    }
  },
  {
    path: '/embed/',
    name: 'Embed',
    components: {
      default: Home
    }
  },
  ChartRoute.create({ title: 'How big is the Pandora Papers leak?', chart: ChartLeakSizeTb }),
  ChartRoute.create({ title: 'How many files are in the Pandora Papers?', chart: ChartLeakSizeDocuments }),
  ChartRoute.create({ title: 'What\'s in the Pandora Papers leak?', chart: ChartDocumentTypes }),
  ChartRoute.create({ title: 'Who are the firms at the heart of the Pandora Papers? ', chart: ChartProvidersOverview }),
  ChartRoute.create({ title: 'Where are the politicians in the Pandora Papers from?', chart: ChartProviderPoliticiansByRegion, name: 'where-are-the-politicians-in-the-pandora-papers-from-1' }),
  ChartRoute.create({ title: 'Top 5 jurisdictions used by politicians in the Pandora Papers', chart: ChartPoliticiansForEachJurisdiction }),
  ChartRoute.create({ title: 'Where are the 336 politicians in the Pandora Papers from?', chart: ChartPoliticiansByCountry }),
  ChartRoute.create({ title: 'How much did the King of Jordan spend on property purchases in the Pandora Papers?', chart: ChartKingOfJordanProperties }),
  ChartRoute.create({ title: 'Which US states have the most trusts in the Pandora Papers? ', chart: ChartUsaTopFiveTrusts }),
  ChartRoute.create({ title: 'Where are the beneficial owners revealed in the Pandora Papers from?', chart: ChartCompaniesByCountry }),
  ChartRoute.create({ title: 'Where are the politicians in the Pandora Papers from?', chart: ChartPoliticiansForEachRegion, name: 'where-are-the-politicians-in-the-pandora-papers-from-2' }),
  ChartRoute.create({ title: 'How many politicians did each firm in the Pandora Papers serve?', chart: ChartPoliticiansForEachProvider }),
  ChartRoute.create({ title: 'Museums holding antiquities linked to accused smuggler', chart: ChartArtsOverview })
]
